import React from 'react';
import { useTranslation } from 'react-i18next';

import { useChatty } from 'component/User/Contact/__hooks/useChatty';

import { Feature } from 'config/features';

import { useFeature } from 'hooks/useFeature';

import { ReactComponent as IconPhoneOutlineWithArrow } from 'media/svg/phoneOutlineWithArrow.svg';
import { ReactComponent as IconStar } from 'media/svg/star.svg';

import LazyImage from 'utility/Bind/Lazy/lazyImage';

import { TravelExpert } from 'proto/TravelExpert/TravelExpert';

import styles from '../Card.module.scss';

export interface ExpertProps {
    expert: TravelExpert;
    customClass?: string;
    serviceCode?: string;
}

const Expert = ({ customClass = '', expert, serviceCode }: ExpertProps) => {
    const { t } = useTranslation();
    const classList = `${styles.Expert} ${customClass}`;
    const rating = expert.rating ?? 0;
    const { openChatty } = useChatty();
    const isTravelExpertRecallActive = useFeature(Feature.TravelExpertRecall);
    const handleOpenChatty = () => {
        openChatty({
            travelExpertRegion: expert.region,
            travelExpertIdHash: expert.idHash,
        });
    };

    return (
        <div className={classList} data-employee-id={expert.idHash}>
            <div className={styles.BubbleWrapper}>
                <div className={styles.Bubble}>
                    {!!expert.quote
                        ? expert.quote
                        : `${t('TRANS-default-expert-quote')}`}
                </div>
            </div>
            <div className={styles.ImageWrapper}>
                <LazyImage
                    width={100}
                    height={100}
                    src={expert.image}
                    alt={`${expert.jobTitle} ${expert.firstName}`}
                />
            </div>
            <div className={styles.Contact}>
                <div className={styles.Person}>
                    <div className={styles.Name}>{expert.firstName}</div>
                    <span className={styles.Rating}>
                        {[...Array(Math.floor(rating))].map((_, index) => {
                            return <IconStar key={index} />;
                        })}
                    </span>
                    {isTravelExpertRecallActive && (
                        <div
                            onClick={() => handleOpenChatty()}
                            className={styles.Recall}
                        >
                            {`${t('TRANS-request-recall')} `}
                            <IconPhoneOutlineWithArrow />
                        </div>
                    )}
                    {!!serviceCode && (
                        <div className={styles.ServiceCode}>
                            {`${t('TRANS-service-code')}:`}
                            <b>{serviceCode}</b>
                        </div>
                    )}
                </div>
                <div className={styles.Job}>
                    <div>
                        <div>{expert.label}</div>
                        <div className={styles.BottomLine}>
                            {expert.special}
                        </div>
                    </div>
                    <div>
                        <div>{expert.experience}</div>
                        <div className={styles.BottomLine}>
                            {expert.education}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Expert;
